/**
 * User Progress Service
 */
import { getApiClient } from '../apiClient';
import { PROGRESS_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
    GetProgressPhotosResponse,
    GetWeightHistoryResponse,
    GetWaterHistoryResponse,
    GetProgressOverviewResponse,
} from '../types/userProgress.types';

export const userProgressService = {
    /**
     * Get progress photos for a user
     */
    getProgressPhotos: (userId: string): Promise<GetProgressPhotosResponse> => {
        const url = replacePathParams(PROGRESS_ENDPOINTS.getPhotos, { userId });
        return getApiClient().get(url);
    },

    /**
     * Get weight history for a user
     */
    getWeightHistory: (userId: string): Promise<GetWeightHistoryResponse> => {
        const url = replacePathParams(PROGRESS_ENDPOINTS.getWeightHistory, { userId });
        return getApiClient().get(url);
    },

    /**
     * Get water history for a user
     */
    getWaterHistory: (userId: string): Promise<GetWaterHistoryResponse> => {
        const url = replacePathParams(PROGRESS_ENDPOINTS.getWaterHistory, { userId });
        return getApiClient().get(url);
    },

    /**
     * Get progress overview for a user
     */
    getProgressOverview: (userId: string): Promise<GetProgressOverviewResponse> => {
        const url = replacePathParams(PROGRESS_ENDPOINTS.getOverview, { userId });
        return getApiClient().get(url);
    },
};
